
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.overlay = this.querySelector('#CartDrawer-Overlay');

    this.overlay?.addEventListener('click', this.close.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE' || event.code === 'Enter') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');

    if (!drawerInner) {
      console.error('Cart drawer inner element not found.');
      return;
    }

    drawerInner.classList.remove('is-empty');

    this.classList.remove('is-empty');

    this.productId = parsedState.id;

    const sections = parsedState.sections || {};

    this.getSectionsToRender().forEach((section) => {
      const sectionHTML = sections[section.id];

      if (!sectionHTML) {
        console.error(
          `Cart drawer section not returned: ${section.id}`
        );
        return;
      }

      const parsedHTML = new DOMParser().parseFromString(
        sectionHTML,
        'text/html'
      );

      const sourceElement = section.selector
        ? parsedHTML.querySelector(section.selector)
        : parsedHTML.getElementById(section.id);

      const targetElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sourceElement || !targetElement) {
        console.error(
          `Cart drawer element missing: ${section.id}`
        );
        return;
      }

      // Replace only the requested section content.
      if (section.selector === '#CartDrawer') {
        targetElement.innerHTML = sourceElement.innerHTML;
      } else {
        targetElement.innerHTML = sourceElement.innerHTML;
      }
    });

    this.overlay = this.querySelector('#CartDrawer-Overlay');

    this.overlay?.addEventListener(
      'click',
      this.close.bind(this)
    );

    const drawerItems = this.querySelector('cart-drawer-items');

    if (drawerItems) {
      drawerItems.dispatchViewEvent?.();
    }

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = parsedHTML.querySelector(selector);

    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    return parsedHTML.querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
